import { ReactNode } from 'react';
import { Text, VStack } from 'app/pages/request-single-page/components-v4';
import { useV4Theme } from 'app/pages/request-single-page/components-v4/theme';
import { ReactComponent as EmptyImage } from '../../../../assets/files/empty-image.svg';

type EmptyProps = {
  action?: ReactNode;
};

export const Empty = ({ action }: EmptyProps) => {
  const theme = useV4Theme();

  return (
    <VStack
      padding={theme.spacings.m}
      align="center"
      style={{
        backgroundColor: theme.colors.primary[50],
        borderRadius: theme.radiuses.xs,
      }}
    >
      <VStack align="center" spacing="xxs">
        <Text variant="heading-3">Прикрепите фото,</Text>
        <Text variant="body-16" color="gray.500">
          и мы быстрее решим проблему
        </Text>
      </VStack>

      <EmptyImage />

      {action}
    </VStack>
  );
};
